import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const ProposalNameStyled = styled.b`
  margin: 0 0.5rem;
  color: ${colors.neutral[900]};
`;
